import type { ReactNode } from 'react';
import '../../styles/auth.css';
import { HelloChapi } from '../../components/motion/Chapis.js';

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="auth">
      <div className="auth-art">
        <img src="/brand/chapsi-logo-horizontal-gradient-reversed.svg" alt="Chapsi" width={113} height={36} style={{ position: 'relative', zIndex: 1, alignSelf: 'flex-start' }} />
        <div>
          <h2>Your clients, your team and the work, in one place.</h2>
          <p>Chat is the record. Tasks, tickets and hours are one click from the conversation.</p>
        </div>
        <div className="chapi">
          <HelloChapi size={110} />
        </div>
      </div>
      <div className="auth-form">
        <div className="auth-card">{children}</div>
      </div>
    </div>
  );
}
